import { saveApi, updateApi, loadApi, deleteApi, deployApi } from "@/store/apis/actions";
import { SdkApi } from "@/interfaces/sdk-api";
import { ETypeNotification, INotification } from "@/interfaces/i-notification";
import { EventBus } from "@/utils/event-bus";
import { downloadFile } from "@/utils/file-download";
import { deployAPI, testAPI } from "@/store/deploy/actions";
import sdkJsonViewer from "@/components/sdk-ui/sdk-json-viewer/sdk-json-viewer.vue";
import SdkSqlEditor from "@/components/sdk-ui/sdk-sql-editor/sdk-sql-editor.vue";
import { tokenInfo } from "@/store/login/types";
import { mapGetters } from "vuex";
import { defineComponent } from "vue";

export default defineComponent({
  name: "sdk-forms-api-single",
  components: {
    SdkSqlEditor,
    sdkJsonViewer,
  },
  data() {
    return {
      loading: false,
      apiformData: {
        name: "",
        allSource: "",
        environment: { id: undefined, company: { id: undefined } },
        id: undefined,
      } as SdkApi,
      newRecord: false,
      code: "",
      notification: [] as INotification[],
      cmOptions: {
        tabSize: 4,
        mode: "text/x-mysql",
        // theme: 'base16-light',
        lineNumbers: true,
        line: true,
      },
      testResult: "",
    };
  },
  computed: {
    ...mapGetters({
      tokenInfo,
    }),
  },
  methods: {
    async fetchApi() {
      this.apiformData = {
        name: "",
        allSource: "",
        environment: { id: undefined, company: { id: undefined } },
        id: undefined,
      } as SdkApi;
      const { id } = this.$route.params;
      if (id === "new") {
        this.apiformData = {
          name: "",
          allSource: "",
          environment: { id: undefined, company: { id: undefined } },
          id: undefined,
        } as SdkApi;
        this.newRecord = true;
      } else {
        this.$dispatch(loadApi)([this.$route.params.id]).then((data: SdkApi) => (this.apiformData = data));
      }
    },
    async deploy() {
      await this.$dispatch(deployApi)(
        [this.$route.params.id, this.tokenInfo.environment.id],
        this.$t("forms.apiItem.notifications.download.success")
      ).then((res: any) => {
        downloadFile(this.apiformData.name, res);
      });
    },
    formatApiContent() {
      if (this.apiformData.allSource.includes(";") && this.apiformData.allSource[this.apiformData.allSource.length - 1] === ";") {
        this.apiformData.allSource = this.apiformData.allSource.slice(0, this.apiformData.allSource.length - 1);
      }
    },
    async save() {
      this.apiformData.environment.id = this.tokenInfo.environment.id;
      if (this.apiformData.name !== "") {
        this.formatApiContent();
        console.log(this.apiformData.allSource);
        await this.$dispatch(saveApi)([this.apiformData], this.$t("forms.apiItem.notifications.save.success")).then(() => this.endCreation());
      } else {
        this.notification.push({
          type: ETypeNotification.DANGER,
          title: this.$t("forms.apiItem.notifications.error.warning") as string,
          message: this.$t("forms.apiItem.notifications.error.message") as string,
        });
        EventBus.$emit("emmit-notification", this.notification[0]);
        this.notification = [];
      }
    },
    async update() {
      this.apiformData.environment.id = this.tokenInfo.environment.id;
      if (this.apiformData.name !== "") {
        this.formatApiContent();
        await this.$dispatch(updateApi)([this.apiformData], this.$t("forms.apiItem.notifications.update.success"));
        // .then(() => this.endCreation() );
      } else {
        this.notification.push({
          type: ETypeNotification.DANGER,
          title: this.$t("forms.apiItem.notifications.error.warning") as string,
          message: this.$t("forms.apiItem.notifications.error.message") as string,
        });
        EventBus.$emit("emmit-notification", this.notification[0]);
        this.notification = [];
      }
    },
    async del() {
      await this.$dispatch(deleteApi)([this.$route.params.id], this.$t("forms.apiItem.notifications.delete.success")).then(() => {
        this.endCreation();
      });
    },
    async test() {
      await this.$dispatch(testAPI)([this.$route.params.id]).then((res: any) => {
        this.testResult = res;
      });
    },
    async deployAPI() {
      await this.$dispatch(deployAPI)([this.$route.params.id], this.$t("forms.apiItem.notifications.deploy.success")).then((res: any) => res);
    },
    endCreation() {
      this.$router.push({ name: "apis" });
    },
    onCmCodeChange(newCode: any) {
      this.apiformData.allSource = newCode;
      this.code = newCode;
    },
  },
  mounted() {
    this.fetchApi();
  },
});
